import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { PostService } from '../../../service/post-service/post.service';

@Component({
  selector: 'app-post-toolbox',
  templateUrl: './post-toolbox.component.html',
  styleUrl: './post-toolbox.component.scss'
})
export class PostToolboxComponent {
  @Output() buttonAction = new EventEmitter();

  public postLoading$ = this.injector.get(PostService).loading; // BehaviorSubject<boolean>

  constructor(
    private injector: Injector) { }

  async onButtonAction(buttonAction: String, parameter: any) {
    const data = { action: buttonAction, param: parameter };
    this.buttonAction.emit(data);
  };

}
